import * as React from 'react';
import { TourPlaceholder } from '../../components/TourPlaceholder';
import { useSelector } from 'react-redux';
import { selectImages, selectTour } from '../../selectors';
import { Section } from '../../components/Section';
import { useDeviceType } from '@cian/ui-kit';
import { TourModalContainer, TourModalContainerMobile } from '../TourModalContainer';
import { TourSection } from '../../components/TourSection';

export const TourSectionContainer = () => {
  const [modalOpened, openModal] = React.useState(false);
  const { images } = useSelector(selectImages);
  const tour = useSelector(selectTour);
  const deviceType = useDeviceType();

  const TourModalComponent = deviceType === 'desktop' ? TourModalContainer : TourModalContainerMobile;

  if (!tour) {
    return null;
  }

  return (
    <Section title="3D–тур по дому">
      <TourSection>
        <TourPlaceholder src={images[0]?.full} onClick={() => openModal(true)} />
      </TourSection>
      {modalOpened && <TourModalComponent onClose={() => openModal(false)} />}
    </Section>
  );
};
